import { useCallback, useEffect, useState } from 'react';

export const useCountDown = () => {
  const [seconds, setSeconds] = useState(60);
  const [showRepeatButton, setShowRepeatButton] = useState(false);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    if (seconds === 0) {
      setShowRepeatButton(true);
    }

    return () => clearTimeout(timerId);
  }, [seconds]);

  const start = useCallback((from: number) => {
    setShowRepeatButton(false);
    setSeconds(from);
  }, []);

  return {
    seconds,
    showRepeatButton,
    start,
  };
};
